import { IBoundedByCorner } from '../../types/location';
import { IBoundedByCornerSchema } from '../../repositories/geo-temp-layer/entities/catalog_item/BoundedByCornerSchema';

export const prepareBoundedByCorner = ({ lat, lng }: IBoundedByCornerSchema): IBoundedByCorner => {
  return {
    lat,
    lng,
  };
};
